import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

export default function SuperAdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/reports/superadmin').then(r => setData(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <><div className="loading-page"><div className="spinner" /></div></>;

  return (
    <>
      <div className="page-header">
        <div className="page-header-text">
          <h2>Panel General</h2>
          <p>Vista global de toda la plataforma</p>
        </div>
        <span className="badge badge-gold">Super Administrador</span>
      </div>

      <div className="stats-grid">
        {[
          { label: 'Negocios totales', value: data?.businesses?.total || 0, icon: '🏪', color: 'gold' },
          { label: 'Negocios activos', value: data?.businesses?.active || 0, icon: '✅', color: 'green' },
          { label: 'Suspendidos', value: data?.businesses?.suspended || 0, icon: '⚠️', color: 'orange' },
          { label: 'Usuarios', value: data?.total_users || 0, icon: '👥', color: 'blue' },
          { label: 'Citas hoy', value: data?.appointments_today || 0, icon: '📅', color: 'gold' },
        ].map(s => (
          <div key={s.label} className="stat-card">
            <div className={`stat-icon ${s.color}`}>{s.icon}</div>
            <div>
              <div className="stat-value">{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      {data?.by_plan?.length > 0 && (
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Negocios por Plan</h3>
          </div>
          <div className="table-wrapper">
            <table>
              <thead><tr><th>Plan</th><th>Negocios registrados</th></tr></thead>
              <tbody>
                {data.by_plan.map(p => (
                  <tr key={p.display_name}>
                    <td><span className="badge badge-gold">{p.display_name}</span></td>
                    <td style={{ fontWeight: 600 }}>{p.businesses}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
